import React from 'react';
import { Logo } from './Logo';
import { footerLinks, contact } from '../data/site';
export function Footer() {
  return <footer className="w-full bg-ink pt-16" data-id="element-232" data-mp="3gg10u7y865zr">
      <div className="mx-auto max-w-[1280px] px-6 lg:px-10" data-id="element-233" data-mp="3gh3n22klrk9c">
        <div className="grid gap-12 border-b border-white/10 pb-14 lg:grid-cols-[1.4fr_0.8fr_1fr]" data-id="element-234" data-mp="32pffmclatjyp">
          <div data-id="element-235" data-mp="36pzaf9iegbho">
            <Logo tone="light" data-id="element-236" data-mp="36nd4feb5q41k" />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/60" data-id="element-237" data-mp="3ufa5cad2jbnw">
              Reliable refrigerated and dry freight transportation serving customers across the United States.
            </p>
          </div>

          <nav aria-label="Footer" data-id="element-238" data-mp="3lf5b71wvy9ro">
            <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-ice-400" data-id="element-239" data-mp="3le2kov3h69ca">Navigation</p>
            <ul className="mt-5 space-y-3" data-id="element-240" data-mp="3qfjj8jyhljpp">
              {footerLinks.map(link => <li key={link.href} data-id="element-241" data-mp="29xvp07mdh3mo">
                  <a href={link.href} className="text-sm text-white/60 transition-colors duration-150 ease-premium hover:text-white" data-id="element-242" data-mp="2ey09e8qeiii6">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-243" data-mp="3v89fgibls1ig">
            <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-ice-400" data-id="element-244" data-mp="3v8rf7oxh4xv4">Contact</p>
            <ul className="mt-5 space-y-3 text-sm text-white/60" data-id="element-245" data-mp="3q7lr64erdyrx">
              <li data-id="element-246" data-mp="82qthw25bzvb">
                <a href={contact.phoneHref} className="transition-colors duration-150 ease-premium hover:text-white" data-id="element-247" data-mp="828q8fh2gldw">
                  {contact.phone}
                </a>
              </li>
              <li data-id="element-248" data-mp="huwhyvt6vz5r">
                <a href={`mailto:${contact.email}`} className="transition-colors duration-150 ease-premium hover:text-white" data-id="element-249" data-mp="ctqo2unsm5un">
                  {contact.email}
                </a>
              </li>
              <li data-id="element-250" data-mp="mt7qn37r03me">{contact.hq}</li>
              <li className="text-white/40" data-id="element-251" data-mp="mq3g7o3owbna">{contact.site}</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col gap-6 py-8 lg:flex-row lg:items-center lg:justify-between" data-id="element-252" data-mp="yu7g0n81bhw3">
          <div className="text-xs leading-relaxed text-white/45" data-id="element-253" data-mp="13tammc3nxw66">
            <p className="font-semibold text-white/70" data-id="element-254" data-mp="13rpokci53v3k">Hold Fast Hauling</p>
            <p data-id="element-255" data-mp="18l2dknqqe3wu">A Division of G&amp;D Property Solutions LLC</p>
            <p data-id="element-256" data-mp="1clm95mvnozgv">Established 2018</p>
          </div>
          <p className="text-xs text-white/40" data-id="element-257" data-mp="1cl2ssalnmj4y">© 2026 Hold Fast Hauling. All Rights Reserved.</p>
        </div>
      </div>
    </footer>;
}